<template>
  <div>
    <!-- <el-container class="pageBox"> -->
    <!-- <el-container class="root"> -->
    <!-- <el-container> -->
    <!-- <el-main class="pageHome"> -->
    <el-container class="pageBox">
      <el-header class="headerBox">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <logo class="logoBox" />
          <div class="menuBox">
            <top-nav v-if="$globalVariable.menuDirection == 'top'" />
          </div>
        </div>

        <!-- <user-box class="userBox" /> -->
      </el-header>
      <div style="background: #f4f4f4">
        <el-aside
          class="sideBar"
          v-if="$globalVariable.menuDirection == 'right'"
        >
          <right-nav></right-nav>
        </el-aside>
        <el-main class="pageMain pageHome">
          <info v-if="$route.meta.title != 'Home'" />
          <keep-alive>
            <router-view :key="key" v-if="$route.meta.noCache" />
          </keep-alive>
          <router-view :key="key" v-if="!$route.meta.noCache" />
        </el-main>
      </div>
      <el-footer class="footerBox">
        <footer-Box></footer-Box>
      </el-footer>
    </el-container>
    <!-- </el-main> -->
    <!-- </el-container> -->
    <!-- </el-container> -->

    <!-- </el-container> -->
  </div>
</template>

<script>
export default {
  name: "Layout",
  props: {
    //传值
  },
  data() {
    return {};
  },
  components: {
    //引入模块
    topNav: () => import("@/components/Navbar/topNav"),
    rightNav: () => import("@/components/Navbar/rightNav"),
    logo: () => import("@/components/logo/index"),
    userBox: () => import("@/components/userBox/index"),
    footerBox: () => import("@/components/footerBox/index"),
    info: () => import("@/components/info/index"),
  },
  watch: {
    // watch擅长处理的场景：一个数据影响多个数据
  },
  computed: {
    // computed擅长处理的场景：一个数据受多个数据影响
    key() {
      return this.$route.path;
    },
  },
  mounted: function () {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
  },
  activated: function () {
    // 狗子触发顺序最后时执行，当再次进入（前进或者后退）时，只触发activated
  },
  methods: {
    // 组件的方法
  },
  beforeCreate: function () {
    // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  },
  created: function () {
    // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
  },
  beforeMount: function () {
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  beforeUpdate: function () {
    // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  },
  updated: function () {
    // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    // 该钩子在服务器端渲染期间不被调用。
  },
  beforeDestroy: function () {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
  },
  destroyed: function () {
    // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
  },
};
</script>
<style lang="scss" scoped>
.pageBox {
  height: 100vh;
  width: 1520px;
  margin: auto;
  ::v-deep .el-footer {
    // position: absolute;
    height: fit-content !important;
  }

  ::v-deep .el-header {
    position: fixed;
  }
  .headerBox {
    position: relative;
    background: linear-gradient(180deg, #c0e29b 0%, #f4f4f4 100%);
    padding-left: 8%;
    padding-right: 8%;
    height: auto !important;
    // width: fit-content;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    .logoText {
      font-size: 32px;
      font-weight: bold;
      color: #2d7055;
    }
    /* div:nth-child(2) {
      min-width: 95%;
    } */
    .userBox {
      position: absolute;
      right: 8%;
    }
  }
  // .root {
  // height: calc(100vh - $TopHeight);
  // min-height: calc(100vh - $main-height);
  /* .sideBar {
      width: 210px !important;
    } */
  .pageHome {
    // padding: 0 !important;
    overflow: hidden;
    background: white;
    min-height: calc(100vh - 181px);
    width: 86%;
    margin: 1% auto;
    border-radius: 5px;
    .pageMain {
      // padding: 0;
      overflow: hidden;
    }
  }
}
@media screen and (max-width: 1920px) and (min-width: 1680px) {
  .pageBox {
    width: 1900px;
  }
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .pageBox {
    width: 1200px;
  }
}
@media screen and (max-width: 1366px) and (min-width: 1280px) {
  .pageBox {
    width: 1300px;
  }
}
@media screen and (max-width: 1600px) and (min-width: 1366px) {
  .pageBox {
    width: 1520px;
  }
}
@media screen and (max-width: 1680px) and (min-width: 1600px) {
  .pageBox {
    width: 1600px;
  }
}
/* @media screen and (min-width: 1200px)  {
  .pageBox {
    width: 1100px;
  }
} */
// }
.footerBox {
  padding-top: 6px;
  background: #218147;
  text-align: center;
  line-height: 1.8;
  color: white;
}
.menuBox {
  width: 1300px;
}
/* @media (min-width: 1900px) {
  .menuBox {
    width: 75%;
  }
} */
.logoBox {
  width: fit-content;
}
/* @media (min-width: 1900px) {
  .logoBox {
    width: 25%;
  }
} */
</style>